import React, { useCallback } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { 
  currentSection as currentSectionState, 
  selectedService as selectedServiceState, 
  showService as showServiceState 
} from '../../store/uiStore'

import { AppNavigation } from '../../styles/headerStyles'
import BackButton from './BackButton'
import ServiceLogo from './ServiceLogo'

const ServiceHeader = () => {
  const [currentSection, setCurrentSection] = useRecoilState(currentSectionState)
  const setSelectedService = useSetRecoilState(selectedServiceState)
  const setShowService = useSetRecoilState(showServiceState)

  const handleBackToServices = useCallback(() => {
    setSelectedService((last) => -1)
    setShowService((last) => false)
    setCurrentSection((last) => 'servicios')
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  const headerVars = {
    hidden: {
      opacity: 0,
      x: '100%',
    },
    visible: {
      opacity: 1,
      x: 0,
    },
  }
  return (
    <AnimatePresence>
      {['servicio'].includes(currentSection) && (
        <AppNavigation
          initial='hidden'
          animate='visible'
          exit='hidden'
          variants={headerVars}
          transition={{
            default: {
              duration: 1.25,
              ease: 'easeOut',
            },
            opacity: {
              duration: 1.5,
              ease: 'linear',
            },
          }}>
          <BackButton label='' handle={handleBackToServices} />
          <ServiceLogo />
        </AppNavigation>
      )}
    </AnimatePresence>
  )
}

export default ServiceHeader
